import { ApiRequest, ApiResponse } from 'services/providers/dapv.types';
import { dapvApi } from 'services/providers/dapv';
import { CreateUserPayload, UpdateUserPayload } from './user.types';
import { User, UserConnection } from 'services/auth/auth.types';

const userApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getMe: build.mutation<ApiResponse<User>, ApiRequest<any>>({
            query: () => ({
                url: `/core/user/me`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        // AppBundle Requests
        getAllConnections: build.mutation<ApiResponse<Array<UserConnection>>, ApiRequest<any>>({
            query: () => ({
                url: `/app/users/connections`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<Array<UserConnection>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getAllUsers: build.mutation<ApiResponse<Array<User>>, ApiRequest<any>>({
            query: () => ({
                url: `/app/users`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<Array<User>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getUser: build.mutation<ApiResponse<User>, ApiRequest<any>>({
            query: (userId: string) => ({
                url: `/app/users/${userId}`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createUser: build.mutation<ApiResponse<User>, CreateUserPayload>({
            query: (body: CreateUserPayload) => ({
                url: `/app/users`,
                method: 'POST',
                body
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateUser: build.mutation<ApiResponse<User>, UpdateUserPayload>({
            query: (body: UpdateUserPayload) => ({
                url: `/app/users/${body.id}`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updateMe: build.mutation<ApiResponse<User>, UpdateUserPayload>({
            query: (body: UpdateUserPayload) => ({
                url: `/core/user`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),

        acceptPrivacyPolicy: build.mutation<ApiResponse<User>, ApiRequest<any>>({
            query: () => ({
                url: `/core/user/privacy-policy`,
                method: 'PUT'
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        // UserBundle Requests
        getUserProfile: build.mutation<ApiResponse<User>, ApiRequest<any>>({
            query: () => ({
                url: `/user/persons/me`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<User>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useGetMeMutation,
    useUpdateUserMutation,
    useUpdateMeMutation,
    useGetUserProfileMutation,
    useGetAllUsersMutation,
    useCreateUserMutation,
    useGetUserMutation,
    useGetAllConnectionsMutation,
    useAcceptPrivacyPolicyMutation
} = userApi;
